<template>
  <div class="container" :class="[altLayout ? 'layout-alt' : '']">
    <div class="info">
      <div class="logo">
        <img :src="getLogo(item.logo)" :alt="item.name">
      </div>
      <h1 class="heading">{{ item.heading }}</h1>
      <p class="lead">
        {{ item.lead }}
      </p>
      <p class="note" v-if="item.note">
        {{ item.note }}
      </p>
      <div class="actions">
        <div class="discount" v-if="item.code">
          <strong class="label">Kode:</strong>
          <div class="code" @click="copyToClipboard(item.code)">
            <span class="content">{{ item.code }}</span>
            <div class="success" v-if="copied">Copied to clipboard!</div>
          </div>
        </div>
        <a :href="item.url" target="_blank" class="cta alt external" @click="track(`${item.name}-visit-store`)">
          Gå til nettbutikk
        </a>
      </div>
    </div>
    <div class="products">
      <ExpanderScroller :items="item.items" :reverse="altLayout" @track="track(`${item.name}-${$event}`)" />
    </div>
  </div>
</template>

<script>
  import ExpanderScroller from './ExpanderScroller.vue'

  export default {
    name: 'HelthjemBrand',
    components: {
      ExpanderScroller,
    },
    emits: ['track'],
    props: {
      item: Object,
      altLayout: Boolean
    },
    data() {
      return {
        copied: false,
      }
    },
    methods: {
      getLogo(logo) {
        return require(`@/assets/brands/${logo}`)
      },
      copyToClipboard(text) {
        navigator.clipboard.writeText(text).then( () => {
          this.copied = true
          this.track(`${this.item.name}-copy-code`)
          setTimeout(() => {
            this.copied = false
          }, (3000));
        })
      },
      track(label) {
        this.$emit('track', label)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .container {
    padding: 4rem 0;
    background: #F7FBF8;
    @include d {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6rem 0 6rem 7.5rem;
    }
    &.layout-alt {
      background: #FAF7F5;
      @include d {
        flex-direction: row-reverse;
        padding: 6rem 7.5rem 6rem 0;
      }
    }
    // &.color-grey {
    //   background: #FAF7F5;
    // }
    .info {
      padding: 0 1.5rem ;
      margin-bottom: 3rem;
      @include d {
        padding: 0;
        // width: 26.25rem;
        width: 23rem;
      }
      .logo {
        margin-bottom: 1.5rem;
        @include d {
          margin-bottom: 2rem;
        }
        img {
          width: auto;
          max-width: none;
          height: 2rem;
          @include d {
            height: 3.125rem;
          }
        }
      }
      .heading {
        margin-bottom: .75rem;
        font-size: 1.75rem;
        font-weight: 900;
        color: $color-1;
        @include d {
          margin-bottom: 1rem;
          font-size: 2.375rem;
        }
      }
      .lead {
        margin-bottom: .75rem;
        font-size: .875rem;
        line-height: 1.25rem;
        @include d {
          margin-bottom: 1rem;
          font-size: 1rem;
          line-height: 1.5rem;
        }
      }
      .note {
        font-style: italic;
        font-size: .625rem;
        color: #737373;
        @include d {
          font-size: .75rem;
        }
      }
      .actions {
        display: flex;
        align-items: center;
        margin-top: 1.5rem;
        .discount {
          display: flex;
          align-items: center;
          margin-right: 1.5rem;
          white-space: nowrap;
          .label {
            margin-right: .5rem;
            font-size: .75rem;
            font-weight: bold;
            @include d {
              font-size: .875rem;
            }
          }
          .code {
            position: relative;
            padding: .375rem .625rem;
            font-size: .75rem;
            border-radius: 0.25rem;
            background: rgba(#EAF2FF, .6);
            border: 1px dashed rgba(5, 5, 5, 0.45);
            cursor: pointer;
            @include d {
              padding: .5rem .75rem;
              font-size: .875rem;
            }
            &:hover {
              background: #EAF2FF;
              border: 1px dashed rgba(5, 5, 5, 0.75);
            }
            &::after {
              content: '';
              position: relative;
              top: .125rem;
              display: inline-block;
              width: .875rem;
              height: .875rem;
              margin-left: .5rem;
              background: url('../assets/icons/copy.svg') no-repeat center center / contain;
            }
            .success {
              left: 50%;
              bottom: -1.75rem;
              position: absolute;
              background: #000;
              padding: .125rem .25rem;
              color: #fff;
              white-space: nowrap;
              border-radius: .125rem;
              transform: translate(-50%, 0);
              animation: fadeout 1s linear 1s 1 normal forwards;
              pointer-events: none;
              &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: -.25rem;
                width: 0;
                height: 0;
                border-left: .25rem solid transparent;
                border-right: .25rem solid transparent;
                border-bottom: .25rem solid #000;
              }
            }
          }
        }
      }
    }
    .products {
      @include d {
        // width: 50rem;
        width: 43rem;
      }
    }
  }

  @keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>
